import { render, staticRenderFns } from "./TicketScanForm.vue?vue&type=template&id=1864029d&scoped=true"
import script from "./TicketScanForm.vue?vue&type=script&lang=ts"
export * from "./TicketScanForm.vue?vue&type=script&lang=ts"
import style0 from "./TicketScanForm.vue?vue&type=style&index=0&id=1864029d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864029d",
  null
  
)

export default component.exports